import { createReducer } from '@reduxjs/toolkit';
import { fetchSettings } from '../actions/SettingsActions';
const initialState = {
  isLoaded: false,
  isFetching: false,
  isError: false
};
export default createReducer(initialState, builder => {
  builder.addCase(fetchSettings.pending, state => {
    state.isFetching = true;
  }).addCase(fetchSettings.fulfilled, state => {
    state.isError = false;
    state.isFetching = false;
    state.isLoaded = true;
  }).addCase(fetchSettings.rejected, state => {
    state.isError = true;
    state.isFetching = false;
    state.isLoaded = false;
  });
});